import Routes from "./utils/Routes";
import "./App.css";

function App() {
  return (
    <>
      <Routes />
    </>
  );
}

export default App;
